<template>
    <span v-if="animaNumber">
    {{ new Intl.NumberFormat('ru-RU').format(animaNumber.toFixed(0)) }}&nbsp;₽
  </span>
</template>

<script>
import { gsap } from "gsap";

export default {
    name : "AnimatedNumber",
    props: {
        number  : Number,
    },
    data() {
        return {
            animaNumber: this.number,
        }
    },
    watch: {
        number: function() {
            gsap.to(this.$data, {duration: 0.5, animaNumber: this.number})
        },
    },
}
</script>

<style scoped>

</style>